"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToggleSwitch = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const GlobalStateProvider_1 = require("../../GlobalStateProvider");
exports.ToggleSwitch = react_1.default.memo(({ text, isOn, setIsOn, }) => {
    const { isMobile, isTablet, isDesktop } = (0, GlobalStateProvider_1.useGlobalState)();
    const handleToggle = () => {
        setIsOn(!isOn);
    };
    return (react_1.default.createElement(StyledMyQnA, { className: "toggle-switch-wrap", "$isOn": isOn, "$isMobile": isMobile, "$isTablet": isTablet, onClick: handleToggle },
        react_1.default.createElement("div", { className: "toggle-switch" },
            react_1.default.createElement("div", { className: "ellipse" })),
        text && react_1.default.createElement("div", { className: "label" }, text)));
});
const StyledMyQnA = styled_components_1.default.div `
	display: flex;
	flex-direction: row;
	gap: 8px;
	align-items: center;
	justify-content: flex-start;
	position: relative;
	cursor: pointer;

	.toggle-switch {
		background: ${({ $isOn }) => ($isOn ? '#a08ede' : '#ccc')};
		border-radius: 100px;
		padding: 4px;
		display: flex;
		align-items: center;
		justify-content: ${({ $isOn }) => ($isOn ? 'flex-end' : 'flex-start')};
		width: 52px;
		transition: background 0.3s, justify-content 0.3s;
	}

	.ellipse {
		background: #ffffff;
		border-radius: 50%;
		width: 18px;
		height: 18px;
		flex-shrink: 0;
	}

	.label {
		color: #101010;
		font-family: 'Noto Sans KR', sans-serif;
		font-size: ${({ $isMobile }) => ($isMobile ? '14px' : '16px')};
		line-height: 32px;
		letter-spacing: -0.02em;
		font-weight: 400;
		text-overflow: ellipsis;
		overflow: hidden;
		white-space: nowrap;
	}
`;
